// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.12.4
//   protoc               unknown
// source: qonto/kycb/api/kyc_verification/firstparty/v3/send_kyc_sms.proto

/* oxlint-disable */

/** Request message for SendKycSms. */
export interface ApiSendKycSmsRequest {
  /** Generated alphanumeric random redo token (path parameter). */
  readonly redoToken: string;
  /** KYC details for sending the SMS. */
  readonly kyc: ApiSendKycSmsRequestKyc | null;
}

/** KYC SMS details. */
export interface ApiSendKycSmsRequestKyc {
  /** Generated alphanumeric random redo token. */
  readonly redoToken: string;
  /** Template name identifying which SMS content will be used for specific KYC provider. */
  readonly templateName: string;
}

/** Response message for SendKycSms. */
export interface ApiSendKycSmsResponse {
  /** KYC result details. */
  readonly kyc: ApiSendKycSmsResponseKyc | null;
}

/** KYC SMS result. */
export interface ApiSendKycSmsResponseKyc {
  /**
   * Template name used for the SMS.
   * Possible values: "idnow-app-link", "qonto-verification-fourthline"
   */
  readonly templateName: string;
}

/** Error definitions for SendKycSms. */
export interface ApiSendKycSmsErrors {
}

/** Not found error codes. */
export const ApiSendKycSmsErrorsNotFoundError = {
  /** NOT_FOUND_ERROR_UNSPECIFIED - Unspecified not found error. */
  NOT_FOUND_ERROR_UNSPECIFIED: "NOT_FOUND_ERROR_UNSPECIFIED",
  /** NOT_FOUND_ERROR_CHECK_NOT_FOUND - Provider check (IDNow or Fourthline) not found. */
  NOT_FOUND_ERROR_CHECK_NOT_FOUND: "NOT_FOUND_ERROR_CHECK_NOT_FOUND",
} as const;

export type ApiSendKycSmsErrorsNotFoundError =
  typeof ApiSendKycSmsErrorsNotFoundError[keyof typeof ApiSendKycSmsErrorsNotFoundError];

export namespace ApiSendKycSmsErrorsNotFoundError {
  export type NOT_FOUND_ERROR_UNSPECIFIED = typeof ApiSendKycSmsErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  export type NOT_FOUND_ERROR_CHECK_NOT_FOUND = typeof ApiSendKycSmsErrorsNotFoundError.NOT_FOUND_ERROR_CHECK_NOT_FOUND;
}

export function apiSendKycSmsErrorsNotFoundErrorFromJSON(object: any): ApiSendKycSmsErrorsNotFoundError {
  switch (object) {
    case 0:
    case "NOT_FOUND_ERROR_UNSPECIFIED":
      return ApiSendKycSmsErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
    case 1:
    case "NOT_FOUND_ERROR_CHECK_NOT_FOUND":
      return ApiSendKycSmsErrorsNotFoundError.NOT_FOUND_ERROR_CHECK_NOT_FOUND;
    default:
      return ApiSendKycSmsErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED;
  }
}

export function apiSendKycSmsErrorsNotFoundErrorToJSON(object: ApiSendKycSmsErrorsNotFoundError): string {
  switch (object) {
    case ApiSendKycSmsErrorsNotFoundError.NOT_FOUND_ERROR_UNSPECIFIED:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
    case ApiSendKycSmsErrorsNotFoundError.NOT_FOUND_ERROR_CHECK_NOT_FOUND:
      return "NOT_FOUND_ERROR_CHECK_NOT_FOUND";
    default:
      return "NOT_FOUND_ERROR_UNSPECIFIED";
  }
}

/** Unprocessable entity error codes. */
export const ApiSendKycSmsErrorsUnprocessableEntityError = {
  /** UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED - Unspecified unprocessable entity error. */
  UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED: "UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED",
  /** UNPROCESSABLE_ENTITY_ERROR_INVALID_PAYLOAD - Invalid payload. */
  UNPROCESSABLE_ENTITY_ERROR_INVALID_PAYLOAD: "UNPROCESSABLE_ENTITY_ERROR_INVALID_PAYLOAD",
} as const;

export type ApiSendKycSmsErrorsUnprocessableEntityError =
  typeof ApiSendKycSmsErrorsUnprocessableEntityError[keyof typeof ApiSendKycSmsErrorsUnprocessableEntityError];

export namespace ApiSendKycSmsErrorsUnprocessableEntityError {
  export type UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED =
    typeof ApiSendKycSmsErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED;
  export type UNPROCESSABLE_ENTITY_ERROR_INVALID_PAYLOAD =
    typeof ApiSendKycSmsErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_INVALID_PAYLOAD;
}

export function apiSendKycSmsErrorsUnprocessableEntityErrorFromJSON(
  object: any,
): ApiSendKycSmsErrorsUnprocessableEntityError {
  switch (object) {
    case 0:
    case "UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED":
      return ApiSendKycSmsErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED;
    case 1:
    case "UNPROCESSABLE_ENTITY_ERROR_INVALID_PAYLOAD":
      return ApiSendKycSmsErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_INVALID_PAYLOAD;
    default:
      return ApiSendKycSmsErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED;
  }
}

export function apiSendKycSmsErrorsUnprocessableEntityErrorToJSON(
  object: ApiSendKycSmsErrorsUnprocessableEntityError,
): string {
  switch (object) {
    case ApiSendKycSmsErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED:
      return "UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED";
    case ApiSendKycSmsErrorsUnprocessableEntityError.UNPROCESSABLE_ENTITY_ERROR_INVALID_PAYLOAD:
      return "UNPROCESSABLE_ENTITY_ERROR_INVALID_PAYLOAD";
    default:
      return "UNPROCESSABLE_ENTITY_ERROR_UNSPECIFIED";
  }
}

/** Too many requests error codes. */
export const ApiSendKycSmsErrorsTooManyRequestsError = {
  /** TOO_MANY_REQUESTS_ERROR_UNSPECIFIED - Unspecified too many requests error. */
  TOO_MANY_REQUESTS_ERROR_UNSPECIFIED: "TOO_MANY_REQUESTS_ERROR_UNSPECIFIED",
  /** TOO_MANY_REQUESTS_ERROR_RATE_LIMIT - Rate limit is hit. */
  TOO_MANY_REQUESTS_ERROR_RATE_LIMIT: "TOO_MANY_REQUESTS_ERROR_RATE_LIMIT",
} as const;

export type ApiSendKycSmsErrorsTooManyRequestsError =
  typeof ApiSendKycSmsErrorsTooManyRequestsError[keyof typeof ApiSendKycSmsErrorsTooManyRequestsError];

export namespace ApiSendKycSmsErrorsTooManyRequestsError {
  export type TOO_MANY_REQUESTS_ERROR_UNSPECIFIED =
    typeof ApiSendKycSmsErrorsTooManyRequestsError.TOO_MANY_REQUESTS_ERROR_UNSPECIFIED;
  export type TOO_MANY_REQUESTS_ERROR_RATE_LIMIT =
    typeof ApiSendKycSmsErrorsTooManyRequestsError.TOO_MANY_REQUESTS_ERROR_RATE_LIMIT;
}

export function apiSendKycSmsErrorsTooManyRequestsErrorFromJSON(object: any): ApiSendKycSmsErrorsTooManyRequestsError {
  switch (object) {
    case 0:
    case "TOO_MANY_REQUESTS_ERROR_UNSPECIFIED":
      return ApiSendKycSmsErrorsTooManyRequestsError.TOO_MANY_REQUESTS_ERROR_UNSPECIFIED;
    case 1:
    case "TOO_MANY_REQUESTS_ERROR_RATE_LIMIT":
      return ApiSendKycSmsErrorsTooManyRequestsError.TOO_MANY_REQUESTS_ERROR_RATE_LIMIT;
    default:
      return ApiSendKycSmsErrorsTooManyRequestsError.TOO_MANY_REQUESTS_ERROR_UNSPECIFIED;
  }
}

export function apiSendKycSmsErrorsTooManyRequestsErrorToJSON(object: ApiSendKycSmsErrorsTooManyRequestsError): string {
  switch (object) {
    case ApiSendKycSmsErrorsTooManyRequestsError.TOO_MANY_REQUESTS_ERROR_UNSPECIFIED:
      return "TOO_MANY_REQUESTS_ERROR_UNSPECIFIED";
    case ApiSendKycSmsErrorsTooManyRequestsError.TOO_MANY_REQUESTS_ERROR_RATE_LIMIT:
      return "TOO_MANY_REQUESTS_ERROR_RATE_LIMIT";
    default:
      return "TOO_MANY_REQUESTS_ERROR_UNSPECIFIED";
  }
}

export const ApiSendKycSmsRequest: MessageFns<ApiSendKycSmsRequest> = {
  fromJSON(object: any): ApiSendKycSmsRequest {
    return {
      redoToken: isSet(object.redoToken)
        ? globalThis.String(object.redoToken)
        : isSet(object.redo_token)
        ? globalThis.String(object.redo_token)
        : "",
      kyc: isSet(object.kyc) ? ApiSendKycSmsRequestKyc.fromJSON(object.kyc) : null,
    };
  },

  toJSON(message: ApiSendKycSmsRequest): unknown {
    const obj: any = {};
    if (message.redoToken !== undefined && message.redoToken !== null) {
      obj.redoToken = message.redoToken;
    }
    if (message.kyc !== undefined && message.kyc !== null) {
      obj.kyc = ApiSendKycSmsRequestKyc.toJSON(message.kyc);
    }
    return obj;
  },
};

export const ApiSendKycSmsRequestKyc: MessageFns<ApiSendKycSmsRequestKyc> = {
  fromJSON(object: any): ApiSendKycSmsRequestKyc {
    return {
      redoToken: isSet(object.redoToken)
        ? globalThis.String(object.redoToken)
        : isSet(object.redo_token)
        ? globalThis.String(object.redo_token)
        : "",
      templateName: isSet(object.templateName)
        ? globalThis.String(object.templateName)
        : isSet(object.template_name)
        ? globalThis.String(object.template_name)
        : "",
    };
  },

  toJSON(message: ApiSendKycSmsRequestKyc): unknown {
    const obj: any = {};
    if (message.redoToken !== undefined && message.redoToken !== null) {
      obj.redoToken = message.redoToken;
    }
    if (message.templateName !== undefined && message.templateName !== null) {
      obj.templateName = message.templateName;
    }
    return obj;
  },
};

export const ApiSendKycSmsResponse: MessageFns<ApiSendKycSmsResponse> = {
  fromJSON(object: any): ApiSendKycSmsResponse {
    return { kyc: isSet(object.kyc) ? ApiSendKycSmsResponseKyc.fromJSON(object.kyc) : null };
  },

  toJSON(message: ApiSendKycSmsResponse): unknown {
    const obj: any = {};
    if (message.kyc !== undefined && message.kyc !== null) {
      obj.kyc = ApiSendKycSmsResponseKyc.toJSON(message.kyc);
    }
    return obj;
  },
};

export const ApiSendKycSmsResponseKyc: MessageFns<ApiSendKycSmsResponseKyc> = {
  fromJSON(object: any): ApiSendKycSmsResponseKyc {
    return {
      templateName: isSet(object.templateName)
        ? globalThis.String(object.templateName)
        : isSet(object.template_name)
        ? globalThis.String(object.template_name)
        : "",
    };
  },

  toJSON(message: ApiSendKycSmsResponseKyc): unknown {
    const obj: any = {};
    if (message.templateName !== undefined && message.templateName !== null) {
      obj.templateName = message.templateName;
    }
    return obj;
  },
};

export const ApiSendKycSmsErrors: MessageFns<ApiSendKycSmsErrors> = {
  fromJSON(_: any): ApiSendKycSmsErrors {
    return {};
  },

  toJSON(_: ApiSendKycSmsErrors): unknown {
    const obj: any = {};
    return obj;
  },
};

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

interface MessageFns<T> {
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
}
